export default __webpack_public_path__ + "static/careers_hero-a67f0211b921eec18a665071d28859a4.jpg";